// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBetmcLDJa7RbCELIQPTFXxozxa57fWvlU",
  authDomain: "bookstore-eedd8.firebaseapp.com",
  projectId: "bookstore-eedd8",
  storageBucket: "bookstore-eedd8.appspot.com",
  messagingSenderId: "217580721712",
  appId: "1:217580721712:web:86cb8c19c743ff57cbbff5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);



export const auth = getAuth(app);
